module.exports = __webpack_public_path__ + "img/user_icon.c51b98b1.svg";